/**
 * @Author: Nenad Brcic
 * @Date: 23.05.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import styles from '../social-share.scss';
import { getCurrentLanguage } from '../../../../localData';
import localize from '../../../../localize';

const Email = ({ title, buttonText, url }) => {
    const l = (key) => {
        const str = `${getCurrentLanguage()}.components.SocialShare.email.${key}`;
        return localize(str);
    };
    const mailTo = `mailto:?subject=${l('subject')}${title}&body=${l('text')}${url}`;

    return (
        <div className="content-box">
            <a href={mailTo} className="SocialMediaShareButton">
                { buttonText }
            </a>
        </div>
    );
};

Email.propTypes = {
    title: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

export default CSSModules(Email, styles);


// WEBPACK FOOTER //
// ./app/components/shared/SocialShare/service/Email.jsx